module.exports = __webpack_public_path__ + "img/meditation_1000--active.0a7594a0.svg";